module.exports = __webpack_public_path__ + "static/media/tanamabot_2.0.d286b221.png";